import { render, staticRenderFns } from "./EnviarComunicado.vue?vue&type=template&id=a544485a"
import script from "./EnviarComunicado.vue?vue&type=script&lang=js"
export * from "./EnviarComunicado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports